/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateZoomPhoneResult201Response } from '../models';
// @ts-ignore
import { CreateZoomPhoneResultRequest } from '../models';
// @ts-ignore
import { GetCustomDefaultLeadViewSetting404Response } from '../models';
// @ts-ignore
import { GetZoomPhoneResult200Response } from '../models';
// @ts-ignore
import { GetZoomPhoneResultNeighbors200Response } from '../models';
// @ts-ignore
import { GetZoomPhoneResults200Response } from '../models';
// @ts-ignore
import { ImportZoomPhoneResultRequest } from '../models';
// @ts-ignore
import { TranscriptionStatusesZoomPhoneResults200Response } from '../models';
// @ts-ignore
import { UserForDisplay } from '../models';
/**
 * ZoomPhoneResultApi - axios parameter creator
 * @export
 */
export const ZoomPhoneResultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 指定されたZoomPhone結果に対して音声分析を手動で実行するAPI。音声ダウンロード、文字起こし、AI分析までの処理を非同期で開始します。
         * @summary 音声分析実行API
         * @param {number} id ZoomPhone結果ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeZoomPhoneResult: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('analyzeZoomPhoneResult', 'id', id)
            const localVarPath = `/api/user/zoom_phone_results/{id}/analyze`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zoom Phone ウィジェットから通話結果を受信して保存するAPI。 通話情報を保存し、録音ダウンロードタスクを自動的に開始する。 
         * @summary ZoomPhone結果作成API (ウィジェットから)
         * @param {CreateZoomPhoneResultRequest} createZoomPhoneResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createZoomPhoneResult: async (createZoomPhoneResultRequest: CreateZoomPhoneResultRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createZoomPhoneResultRequest' is not null or undefined
            assertParamExists('createZoomPhoneResult', 'createZoomPhoneResultRequest', createZoomPhoneResultRequest)
            const localVarPath = `/api/user/zoom_phone_results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createZoomPhoneResultRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ZoomPhone結果削除API
         * @summary ZoomPhone結果削除API
         * @param {number} id ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteZoomPhoneResult: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteZoomPhoneResult', 'id', id)
            const localVarPath = `/api/user/zoom_phone_results/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ZoomPhone結果取得API
         * @summary ZoomPhone結果取得API
         * @param {number} id ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomPhoneResult: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getZoomPhoneResult', 'id', id)
            const localVarPath = `/api/user/zoom_phone_results/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定したZoomPhone結果の前後のレコードIDとページ番号を取得する
         * @summary ZoomPhone結果の前後レコード取得API
         * @param {number} id ZoomPhoneResult ID
         * @param {string} [startedAtFrom] 
         * @param {string} [startedAtTo] 
         * @param {string} [callerUserId] 
         * @param {string} [calleeDidNumber] 
         * @param {number} [durationFrom] 通話時間（秒）の下限。指定値以上の通話に絞り込む
         * @param {number} [durationTo] 通話時間（秒）の上限。指定値以下の通話に絞り込む
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomPhoneResultNeighbors: async (id: number, startedAtFrom?: string, startedAtTo?: string, callerUserId?: string, calleeDidNumber?: string, durationFrom?: number, durationTo?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getZoomPhoneResultNeighbors', 'id', id)
            const localVarPath = `/api/user/zoom_phone_results/{id}/neighbors`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startedAtFrom !== undefined) {
                localVarQueryParameter['started_at_from'] = startedAtFrom;
            }

            if (startedAtTo !== undefined) {
                localVarQueryParameter['started_at_to'] = startedAtTo;
            }

            if (callerUserId !== undefined) {
                localVarQueryParameter['caller_user_id'] = callerUserId;
            }

            if (calleeDidNumber !== undefined) {
                localVarQueryParameter['callee_did_number'] = calleeDidNumber;
            }

            if (durationFrom !== undefined) {
                localVarQueryParameter['duration_from'] = durationFrom;
            }

            if (durationTo !== undefined) {
                localVarQueryParameter['duration_to'] = durationTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ZoomPhone結果一覧取得API
         * @summary ZoomPhone結果一覧取得API
         * @param {number} [page] infinityLoading用ページ番号
         * @param {string} [startedAtFrom] 
         * @param {string} [startedAtTo] 
         * @param {string} [callerUserId] 
         * @param {string} [calleeDidNumber] 
         * @param {number} [durationFrom] 通話時間（秒）の下限。指定値以上の通話に絞り込む
         * @param {number} [durationTo] 通話時間（秒）の上限。指定値以下の通話に絞り込む
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomPhoneResults: async (page?: number, startedAtFrom?: string, startedAtTo?: string, callerUserId?: string, calleeDidNumber?: string, durationFrom?: number, durationTo?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/zoom_phone_results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startedAtFrom !== undefined) {
                localVarQueryParameter['started_at_from'] = startedAtFrom;
            }

            if (startedAtTo !== undefined) {
                localVarQueryParameter['started_at_to'] = startedAtTo;
            }

            if (callerUserId !== undefined) {
                localVarQueryParameter['caller_user_id'] = callerUserId;
            }

            if (calleeDidNumber !== undefined) {
                localVarQueryParameter['callee_did_number'] = calleeDidNumber;
            }

            if (durationFrom !== undefined) {
                localVarQueryParameter['duration_from'] = durationFrom;
            }

            if (durationTo !== undefined) {
                localVarQueryParameter['duration_to'] = durationTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 発信者一覧取得API
         * @summary 発信者一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomPhoneResultsCallers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/zoom_phone_results/callers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ZoomPhone call_idを受け取り、Zoom APIから通話情報を取得してDB保存する。 
         * @summary ZoomPhoneコール取り込みAPI
         * @param {ImportZoomPhoneResultRequest} importZoomPhoneResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importZoomPhoneResult: async (importZoomPhoneResultRequest: ImportZoomPhoneResultRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importZoomPhoneResultRequest' is not null or undefined
            assertParamExists('importZoomPhoneResult', 'importZoomPhoneResultRequest', importZoomPhoneResultRequest)
            const localVarPath = `/api/user/zoom_phone_results/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importZoomPhoneResultRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定された複数のIDに対して、音声分析ステータスのみを返却する軽量なAPI。ポーリング最適化用。
         * @summary ZoomPhone結果音声分析ステータス取得API
         * @param {Array<number>} [id] 取得対象のZoomPhoneResult IDの配列。all&#x3D;trueの場合は無視される。
         * @param {boolean} [all] trueの場合、すべてのデータのステータスを返す。id[]パラメータは無視される。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptionStatusesZoomPhoneResults: async (id?: Array<number>, all?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/zoom_phone_results/transcription_statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id) {
                localVarQueryParameter['id[]'] = id;
            }

            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZoomPhoneResultApi - functional programming interface
 * @export
 */
export const ZoomPhoneResultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZoomPhoneResultApiAxiosParamCreator(configuration)
    return {
        /**
         * 指定されたZoomPhone結果に対して音声分析を手動で実行するAPI。音声ダウンロード、文字起こし、AI分析までの処理を非同期で開始します。
         * @summary 音声分析実行API
         * @param {number} id ZoomPhone結果ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyzeZoomPhoneResult(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyzeZoomPhoneResult(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Zoom Phone ウィジェットから通話結果を受信して保存するAPI。 通話情報を保存し、録音ダウンロードタスクを自動的に開始する。 
         * @summary ZoomPhone結果作成API (ウィジェットから)
         * @param {CreateZoomPhoneResultRequest} createZoomPhoneResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createZoomPhoneResult(createZoomPhoneResultRequest: CreateZoomPhoneResultRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateZoomPhoneResult201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createZoomPhoneResult(createZoomPhoneResultRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ZoomPhone結果削除API
         * @summary ZoomPhone結果削除API
         * @param {number} id ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteZoomPhoneResult(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteZoomPhoneResult(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ZoomPhone結果取得API
         * @summary ZoomPhone結果取得API
         * @param {number} id ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZoomPhoneResult(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetZoomPhoneResult200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZoomPhoneResult(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定したZoomPhone結果の前後のレコードIDとページ番号を取得する
         * @summary ZoomPhone結果の前後レコード取得API
         * @param {number} id ZoomPhoneResult ID
         * @param {string} [startedAtFrom] 
         * @param {string} [startedAtTo] 
         * @param {string} [callerUserId] 
         * @param {string} [calleeDidNumber] 
         * @param {number} [durationFrom] 通話時間（秒）の下限。指定値以上の通話に絞り込む
         * @param {number} [durationTo] 通話時間（秒）の上限。指定値以下の通話に絞り込む
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZoomPhoneResultNeighbors(id: number, startedAtFrom?: string, startedAtTo?: string, callerUserId?: string, calleeDidNumber?: string, durationFrom?: number, durationTo?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetZoomPhoneResultNeighbors200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZoomPhoneResultNeighbors(id, startedAtFrom, startedAtTo, callerUserId, calleeDidNumber, durationFrom, durationTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ZoomPhone結果一覧取得API
         * @summary ZoomPhone結果一覧取得API
         * @param {number} [page] infinityLoading用ページ番号
         * @param {string} [startedAtFrom] 
         * @param {string} [startedAtTo] 
         * @param {string} [callerUserId] 
         * @param {string} [calleeDidNumber] 
         * @param {number} [durationFrom] 通話時間（秒）の下限。指定値以上の通話に絞り込む
         * @param {number} [durationTo] 通話時間（秒）の上限。指定値以下の通話に絞り込む
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZoomPhoneResults(page?: number, startedAtFrom?: string, startedAtTo?: string, callerUserId?: string, calleeDidNumber?: string, durationFrom?: number, durationTo?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetZoomPhoneResults200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZoomPhoneResults(page, startedAtFrom, startedAtTo, callerUserId, calleeDidNumber, durationFrom, durationTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 発信者一覧取得API
         * @summary 発信者一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZoomPhoneResultsCallers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserForDisplay>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZoomPhoneResultsCallers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ZoomPhone call_idを受け取り、Zoom APIから通話情報を取得してDB保存する。 
         * @summary ZoomPhoneコール取り込みAPI
         * @param {ImportZoomPhoneResultRequest} importZoomPhoneResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importZoomPhoneResult(importZoomPhoneResultRequest: ImportZoomPhoneResultRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateZoomPhoneResult201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importZoomPhoneResult(importZoomPhoneResultRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定された複数のIDに対して、音声分析ステータスのみを返却する軽量なAPI。ポーリング最適化用。
         * @summary ZoomPhone結果音声分析ステータス取得API
         * @param {Array<number>} [id] 取得対象のZoomPhoneResult IDの配列。all&#x3D;trueの場合は無視される。
         * @param {boolean} [all] trueの場合、すべてのデータのステータスを返す。id[]パラメータは無視される。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transcriptionStatusesZoomPhoneResults(id?: Array<number>, all?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranscriptionStatusesZoomPhoneResults200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transcriptionStatusesZoomPhoneResults(id, all, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ZoomPhoneResultApi - factory interface
 * @export
 */
export const ZoomPhoneResultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZoomPhoneResultApiFp(configuration)
    return {
        /**
         * 指定されたZoomPhone結果に対して音声分析を手動で実行するAPI。音声ダウンロード、文字起こし、AI分析までの処理を非同期で開始します。
         * @summary 音声分析実行API
         * @param {number} id ZoomPhone結果ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyzeZoomPhoneResult(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.analyzeZoomPhoneResult(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Zoom Phone ウィジェットから通話結果を受信して保存するAPI。 通話情報を保存し、録音ダウンロードタスクを自動的に開始する。 
         * @summary ZoomPhone結果作成API (ウィジェットから)
         * @param {CreateZoomPhoneResultRequest} createZoomPhoneResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createZoomPhoneResult(createZoomPhoneResultRequest: CreateZoomPhoneResultRequest, options?: any): AxiosPromise<CreateZoomPhoneResult201Response> {
            return localVarFp.createZoomPhoneResult(createZoomPhoneResultRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ZoomPhone結果削除API
         * @summary ZoomPhone結果削除API
         * @param {number} id ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteZoomPhoneResult(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteZoomPhoneResult(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ZoomPhone結果取得API
         * @summary ZoomPhone結果取得API
         * @param {number} id ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomPhoneResult(id: number, options?: any): AxiosPromise<GetZoomPhoneResult200Response> {
            return localVarFp.getZoomPhoneResult(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定したZoomPhone結果の前後のレコードIDとページ番号を取得する
         * @summary ZoomPhone結果の前後レコード取得API
         * @param {number} id ZoomPhoneResult ID
         * @param {string} [startedAtFrom] 
         * @param {string} [startedAtTo] 
         * @param {string} [callerUserId] 
         * @param {string} [calleeDidNumber] 
         * @param {number} [durationFrom] 通話時間（秒）の下限。指定値以上の通話に絞り込む
         * @param {number} [durationTo] 通話時間（秒）の上限。指定値以下の通話に絞り込む
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomPhoneResultNeighbors(id: number, startedAtFrom?: string, startedAtTo?: string, callerUserId?: string, calleeDidNumber?: string, durationFrom?: number, durationTo?: number, options?: any): AxiosPromise<GetZoomPhoneResultNeighbors200Response> {
            return localVarFp.getZoomPhoneResultNeighbors(id, startedAtFrom, startedAtTo, callerUserId, calleeDidNumber, durationFrom, durationTo, options).then((request) => request(axios, basePath));
        },
        /**
         * ZoomPhone結果一覧取得API
         * @summary ZoomPhone結果一覧取得API
         * @param {number} [page] infinityLoading用ページ番号
         * @param {string} [startedAtFrom] 
         * @param {string} [startedAtTo] 
         * @param {string} [callerUserId] 
         * @param {string} [calleeDidNumber] 
         * @param {number} [durationFrom] 通話時間（秒）の下限。指定値以上の通話に絞り込む
         * @param {number} [durationTo] 通話時間（秒）の上限。指定値以下の通話に絞り込む
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomPhoneResults(page?: number, startedAtFrom?: string, startedAtTo?: string, callerUserId?: string, calleeDidNumber?: string, durationFrom?: number, durationTo?: number, options?: any): AxiosPromise<GetZoomPhoneResults200Response> {
            return localVarFp.getZoomPhoneResults(page, startedAtFrom, startedAtTo, callerUserId, calleeDidNumber, durationFrom, durationTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 発信者一覧取得API
         * @summary 発信者一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomPhoneResultsCallers(options?: any): AxiosPromise<Array<UserForDisplay>> {
            return localVarFp.getZoomPhoneResultsCallers(options).then((request) => request(axios, basePath));
        },
        /**
         * ZoomPhone call_idを受け取り、Zoom APIから通話情報を取得してDB保存する。 
         * @summary ZoomPhoneコール取り込みAPI
         * @param {ImportZoomPhoneResultRequest} importZoomPhoneResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importZoomPhoneResult(importZoomPhoneResultRequest: ImportZoomPhoneResultRequest, options?: any): AxiosPromise<CreateZoomPhoneResult201Response> {
            return localVarFp.importZoomPhoneResult(importZoomPhoneResultRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定された複数のIDに対して、音声分析ステータスのみを返却する軽量なAPI。ポーリング最適化用。
         * @summary ZoomPhone結果音声分析ステータス取得API
         * @param {Array<number>} [id] 取得対象のZoomPhoneResult IDの配列。all&#x3D;trueの場合は無視される。
         * @param {boolean} [all] trueの場合、すべてのデータのステータスを返す。id[]パラメータは無視される。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transcriptionStatusesZoomPhoneResults(id?: Array<number>, all?: boolean, options?: any): AxiosPromise<TranscriptionStatusesZoomPhoneResults200Response> {
            return localVarFp.transcriptionStatusesZoomPhoneResults(id, all, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZoomPhoneResultApi - interface
 * @export
 * @interface ZoomPhoneResultApi
 */
export interface ZoomPhoneResultApiInterface {
    /**
     * 指定されたZoomPhone結果に対して音声分析を手動で実行するAPI。音声ダウンロード、文字起こし、AI分析までの処理を非同期で開始します。
     * @summary 音声分析実行API
     * @param {number} id ZoomPhone結果ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApiInterface
     */
    analyzeZoomPhoneResult(id: number, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Zoom Phone ウィジェットから通話結果を受信して保存するAPI。 通話情報を保存し、録音ダウンロードタスクを自動的に開始する。 
     * @summary ZoomPhone結果作成API (ウィジェットから)
     * @param {CreateZoomPhoneResultRequest} createZoomPhoneResultRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApiInterface
     */
    createZoomPhoneResult(createZoomPhoneResultRequest: CreateZoomPhoneResultRequest, options?: AxiosRequestConfig): AxiosPromise<CreateZoomPhoneResult201Response>;

    /**
     * ZoomPhone結果削除API
     * @summary ZoomPhone結果削除API
     * @param {number} id ZoomPhoneResult ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApiInterface
     */
    deleteZoomPhoneResult(id: number, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * ZoomPhone結果取得API
     * @summary ZoomPhone結果取得API
     * @param {number} id ZoomPhoneResult ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApiInterface
     */
    getZoomPhoneResult(id: number, options?: AxiosRequestConfig): AxiosPromise<GetZoomPhoneResult200Response>;

    /**
     * 指定したZoomPhone結果の前後のレコードIDとページ番号を取得する
     * @summary ZoomPhone結果の前後レコード取得API
     * @param {number} id ZoomPhoneResult ID
     * @param {string} [startedAtFrom] 
     * @param {string} [startedAtTo] 
     * @param {string} [callerUserId] 
     * @param {string} [calleeDidNumber] 
     * @param {number} [durationFrom] 通話時間（秒）の下限。指定値以上の通話に絞り込む
     * @param {number} [durationTo] 通話時間（秒）の上限。指定値以下の通話に絞り込む
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApiInterface
     */
    getZoomPhoneResultNeighbors(id: number, startedAtFrom?: string, startedAtTo?: string, callerUserId?: string, calleeDidNumber?: string, durationFrom?: number, durationTo?: number, options?: AxiosRequestConfig): AxiosPromise<GetZoomPhoneResultNeighbors200Response>;

    /**
     * ZoomPhone結果一覧取得API
     * @summary ZoomPhone結果一覧取得API
     * @param {number} [page] infinityLoading用ページ番号
     * @param {string} [startedAtFrom] 
     * @param {string} [startedAtTo] 
     * @param {string} [callerUserId] 
     * @param {string} [calleeDidNumber] 
     * @param {number} [durationFrom] 通話時間（秒）の下限。指定値以上の通話に絞り込む
     * @param {number} [durationTo] 通話時間（秒）の上限。指定値以下の通話に絞り込む
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApiInterface
     */
    getZoomPhoneResults(page?: number, startedAtFrom?: string, startedAtTo?: string, callerUserId?: string, calleeDidNumber?: string, durationFrom?: number, durationTo?: number, options?: AxiosRequestConfig): AxiosPromise<GetZoomPhoneResults200Response>;

    /**
     * 発信者一覧取得API
     * @summary 発信者一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApiInterface
     */
    getZoomPhoneResultsCallers(options?: AxiosRequestConfig): AxiosPromise<Array<UserForDisplay>>;

    /**
     * ZoomPhone call_idを受け取り、Zoom APIから通話情報を取得してDB保存する。 
     * @summary ZoomPhoneコール取り込みAPI
     * @param {ImportZoomPhoneResultRequest} importZoomPhoneResultRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApiInterface
     */
    importZoomPhoneResult(importZoomPhoneResultRequest: ImportZoomPhoneResultRequest, options?: AxiosRequestConfig): AxiosPromise<CreateZoomPhoneResult201Response>;

    /**
     * 指定された複数のIDに対して、音声分析ステータスのみを返却する軽量なAPI。ポーリング最適化用。
     * @summary ZoomPhone結果音声分析ステータス取得API
     * @param {Array<number>} [id] 取得対象のZoomPhoneResult IDの配列。all&#x3D;trueの場合は無視される。
     * @param {boolean} [all] trueの場合、すべてのデータのステータスを返す。id[]パラメータは無視される。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApiInterface
     */
    transcriptionStatusesZoomPhoneResults(id?: Array<number>, all?: boolean, options?: AxiosRequestConfig): AxiosPromise<TranscriptionStatusesZoomPhoneResults200Response>;

}

/**
 * Request parameters for analyzeZoomPhoneResult operation in ZoomPhoneResultApi.
 * @export
 * @interface ZoomPhoneResultApiAnalyzeZoomPhoneResultRequest
 */
export interface ZoomPhoneResultApiAnalyzeZoomPhoneResultRequest {
    /**
     * ZoomPhone結果ID
     * @type {number}
     * @memberof ZoomPhoneResultApiAnalyzeZoomPhoneResult
     */
    readonly id: number
}

/**
 * Request parameters for createZoomPhoneResult operation in ZoomPhoneResultApi.
 * @export
 * @interface ZoomPhoneResultApiCreateZoomPhoneResultRequest
 */
export interface ZoomPhoneResultApiCreateZoomPhoneResultRequest {
    /**
     * 
     * @type {CreateZoomPhoneResultRequest}
     * @memberof ZoomPhoneResultApiCreateZoomPhoneResult
     */
    readonly createZoomPhoneResultRequest: CreateZoomPhoneResultRequest
}

/**
 * Request parameters for deleteZoomPhoneResult operation in ZoomPhoneResultApi.
 * @export
 * @interface ZoomPhoneResultApiDeleteZoomPhoneResultRequest
 */
export interface ZoomPhoneResultApiDeleteZoomPhoneResultRequest {
    /**
     * ZoomPhoneResult ID
     * @type {number}
     * @memberof ZoomPhoneResultApiDeleteZoomPhoneResult
     */
    readonly id: number
}

/**
 * Request parameters for getZoomPhoneResult operation in ZoomPhoneResultApi.
 * @export
 * @interface ZoomPhoneResultApiGetZoomPhoneResultRequest
 */
export interface ZoomPhoneResultApiGetZoomPhoneResultRequest {
    /**
     * ZoomPhoneResult ID
     * @type {number}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResult
     */
    readonly id: number
}

/**
 * Request parameters for getZoomPhoneResultNeighbors operation in ZoomPhoneResultApi.
 * @export
 * @interface ZoomPhoneResultApiGetZoomPhoneResultNeighborsRequest
 */
export interface ZoomPhoneResultApiGetZoomPhoneResultNeighborsRequest {
    /**
     * ZoomPhoneResult ID
     * @type {number}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResultNeighbors
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResultNeighbors
     */
    readonly startedAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResultNeighbors
     */
    readonly startedAtTo?: string

    /**
     * 
     * @type {string}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResultNeighbors
     */
    readonly callerUserId?: string

    /**
     * 
     * @type {string}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResultNeighbors
     */
    readonly calleeDidNumber?: string

    /**
     * 通話時間（秒）の下限。指定値以上の通話に絞り込む
     * @type {number}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResultNeighbors
     */
    readonly durationFrom?: number

    /**
     * 通話時間（秒）の上限。指定値以下の通話に絞り込む
     * @type {number}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResultNeighbors
     */
    readonly durationTo?: number
}

/**
 * Request parameters for getZoomPhoneResults operation in ZoomPhoneResultApi.
 * @export
 * @interface ZoomPhoneResultApiGetZoomPhoneResultsRequest
 */
export interface ZoomPhoneResultApiGetZoomPhoneResultsRequest {
    /**
     * infinityLoading用ページ番号
     * @type {number}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResults
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResults
     */
    readonly startedAtFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResults
     */
    readonly startedAtTo?: string

    /**
     * 
     * @type {string}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResults
     */
    readonly callerUserId?: string

    /**
     * 
     * @type {string}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResults
     */
    readonly calleeDidNumber?: string

    /**
     * 通話時間（秒）の下限。指定値以上の通話に絞り込む
     * @type {number}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResults
     */
    readonly durationFrom?: number

    /**
     * 通話時間（秒）の上限。指定値以下の通話に絞り込む
     * @type {number}
     * @memberof ZoomPhoneResultApiGetZoomPhoneResults
     */
    readonly durationTo?: number
}

/**
 * Request parameters for importZoomPhoneResult operation in ZoomPhoneResultApi.
 * @export
 * @interface ZoomPhoneResultApiImportZoomPhoneResultRequest
 */
export interface ZoomPhoneResultApiImportZoomPhoneResultRequest {
    /**
     * 
     * @type {ImportZoomPhoneResultRequest}
     * @memberof ZoomPhoneResultApiImportZoomPhoneResult
     */
    readonly importZoomPhoneResultRequest: ImportZoomPhoneResultRequest
}

/**
 * Request parameters for transcriptionStatusesZoomPhoneResults operation in ZoomPhoneResultApi.
 * @export
 * @interface ZoomPhoneResultApiTranscriptionStatusesZoomPhoneResultsRequest
 */
export interface ZoomPhoneResultApiTranscriptionStatusesZoomPhoneResultsRequest {
    /**
     * 取得対象のZoomPhoneResult IDの配列。all&#x3D;trueの場合は無視される。
     * @type {Array<number>}
     * @memberof ZoomPhoneResultApiTranscriptionStatusesZoomPhoneResults
     */
    readonly id?: Array<number>

    /**
     * trueの場合、すべてのデータのステータスを返す。id[]パラメータは無視される。
     * @type {boolean}
     * @memberof ZoomPhoneResultApiTranscriptionStatusesZoomPhoneResults
     */
    readonly all?: boolean
}

/**
 * ZoomPhoneResultApi - object-oriented interface
 * @export
 * @class ZoomPhoneResultApi
 * @extends {BaseAPI}
 */
export class ZoomPhoneResultApi extends BaseAPI implements ZoomPhoneResultApiInterface {
    /**
     * 指定されたZoomPhone結果に対して音声分析を手動で実行するAPI。音声ダウンロード、文字起こし、AI分析までの処理を非同期で開始します。
     * @summary 音声分析実行API
     * @param {ZoomPhoneResultApiAnalyzeZoomPhoneResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApi
     */
    public analyzeZoomPhoneResult(requestParameters: ZoomPhoneResultApiAnalyzeZoomPhoneResultRequest, options?: AxiosRequestConfig) {
        return ZoomPhoneResultApiFp(this.configuration).analyzeZoomPhoneResult(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zoom Phone ウィジェットから通話結果を受信して保存するAPI。 通話情報を保存し、録音ダウンロードタスクを自動的に開始する。 
     * @summary ZoomPhone結果作成API (ウィジェットから)
     * @param {ZoomPhoneResultApiCreateZoomPhoneResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApi
     */
    public createZoomPhoneResult(requestParameters: ZoomPhoneResultApiCreateZoomPhoneResultRequest, options?: AxiosRequestConfig) {
        return ZoomPhoneResultApiFp(this.configuration).createZoomPhoneResult(requestParameters.createZoomPhoneResultRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ZoomPhone結果削除API
     * @summary ZoomPhone結果削除API
     * @param {ZoomPhoneResultApiDeleteZoomPhoneResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApi
     */
    public deleteZoomPhoneResult(requestParameters: ZoomPhoneResultApiDeleteZoomPhoneResultRequest, options?: AxiosRequestConfig) {
        return ZoomPhoneResultApiFp(this.configuration).deleteZoomPhoneResult(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ZoomPhone結果取得API
     * @summary ZoomPhone結果取得API
     * @param {ZoomPhoneResultApiGetZoomPhoneResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApi
     */
    public getZoomPhoneResult(requestParameters: ZoomPhoneResultApiGetZoomPhoneResultRequest, options?: AxiosRequestConfig) {
        return ZoomPhoneResultApiFp(this.configuration).getZoomPhoneResult(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定したZoomPhone結果の前後のレコードIDとページ番号を取得する
     * @summary ZoomPhone結果の前後レコード取得API
     * @param {ZoomPhoneResultApiGetZoomPhoneResultNeighborsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApi
     */
    public getZoomPhoneResultNeighbors(requestParameters: ZoomPhoneResultApiGetZoomPhoneResultNeighborsRequest, options?: AxiosRequestConfig) {
        return ZoomPhoneResultApiFp(this.configuration).getZoomPhoneResultNeighbors(requestParameters.id, requestParameters.startedAtFrom, requestParameters.startedAtTo, requestParameters.callerUserId, requestParameters.calleeDidNumber, requestParameters.durationFrom, requestParameters.durationTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ZoomPhone結果一覧取得API
     * @summary ZoomPhone結果一覧取得API
     * @param {ZoomPhoneResultApiGetZoomPhoneResultsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApi
     */
    public getZoomPhoneResults(requestParameters: ZoomPhoneResultApiGetZoomPhoneResultsRequest = {}, options?: AxiosRequestConfig) {
        return ZoomPhoneResultApiFp(this.configuration).getZoomPhoneResults(requestParameters.page, requestParameters.startedAtFrom, requestParameters.startedAtTo, requestParameters.callerUserId, requestParameters.calleeDidNumber, requestParameters.durationFrom, requestParameters.durationTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 発信者一覧取得API
     * @summary 発信者一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApi
     */
    public getZoomPhoneResultsCallers(options?: AxiosRequestConfig) {
        return ZoomPhoneResultApiFp(this.configuration).getZoomPhoneResultsCallers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ZoomPhone call_idを受け取り、Zoom APIから通話情報を取得してDB保存する。 
     * @summary ZoomPhoneコール取り込みAPI
     * @param {ZoomPhoneResultApiImportZoomPhoneResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApi
     */
    public importZoomPhoneResult(requestParameters: ZoomPhoneResultApiImportZoomPhoneResultRequest, options?: AxiosRequestConfig) {
        return ZoomPhoneResultApiFp(this.configuration).importZoomPhoneResult(requestParameters.importZoomPhoneResultRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定された複数のIDに対して、音声分析ステータスのみを返却する軽量なAPI。ポーリング最適化用。
     * @summary ZoomPhone結果音声分析ステータス取得API
     * @param {ZoomPhoneResultApiTranscriptionStatusesZoomPhoneResultsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZoomPhoneResultApi
     */
    public transcriptionStatusesZoomPhoneResults(requestParameters: ZoomPhoneResultApiTranscriptionStatusesZoomPhoneResultsRequest = {}, options?: AxiosRequestConfig) {
        return ZoomPhoneResultApiFp(this.configuration).transcriptionStatusesZoomPhoneResults(requestParameters.id, requestParameters.all, options).then((request) => request(this.axios, this.basePath));
    }
}
